import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Tooltip,
} from "@mui/material";
import React from "react";
import styles from "../Managebatches.module.css";
import DeleteBtn from "../../../../../../components/Buttons/DeleteBtn";
import DeletePopup from "../../../../../../components/CommonPopups/DeletePopup";
import {
  deleteDemoStudent,
  resetBatchPaymentReminderStatus,
  resetBatchStatus,
} from "../../service/Batchslice";
import { useAuthUser } from "react-auth-kit";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import SaveBtn from "../../../../../../components/Buttons/SaveBtn";
import leadActiveDefault from "../../../../../../assets/images/activeLeadDefault.svg";
import leadActiveIcon from "../../../../../../assets/images/activeLead.svg";
import leadLostDefault from "../../../../../../assets/images/lostLeadDefault.svg";
import leadLostIcon from "../../../../../../assets/images/lostLead.svg";
import { findBranchById } from "../../../../../../components/CommonFunctions/CommonFunctions";

function BatchStudents(props: any) {
  const {
    batchData,
    hasBatchAccess,
    batchPaymentReminderSuccess,
    batchPaymentReminderLoading,
    SendPaymentReminderToBatch,
  } = props;
  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch();
  const { demoStudentDeleteSuccess, demoStudentDeleteLoading } = useSelector(
    (state: any) => state.batch
  );

  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [deleteStudent, setDeleteStudent] = React.useState<any>("");
  const [deleteModal, setDeleteModal] = React.useState<boolean>(false);
  const instituteData = useSelector(
    (state: any) => state.institute.instituteDetails
  );
  const [leadStatusCheck, setLeadStatusCheck] = React.useState<boolean>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const handleDelete = (item: any) => {
    setDeleteStudent(item);
    setDeleteModal(true);
  };
  const handleDeleteClosePopup = () => {
    setDeleteStudent("");
    setDeleteModal(false);
  };

  const handleDeleteStudent = async (event: any) => {
    event.preventDefault();

    try {
      const body = {
        batchId: batchData?.id,
        demoId: deleteStudent?.id,
        enquiryId: deleteStudent?.enquiryId,
        createdById: authUser?.institute?.[0]?.id,
        createdByName: authUser?.firstName + " " + authUser?.lastName,
        instituteId: authUser?.institute[0]?.instituteId,
      };
      dispatch<any>(deleteDemoStudent(body));
    } catch (error) {}
  };

  React.useEffect(() => {
    if (
      demoStudentDeleteSuccess !== true &&
      demoStudentDeleteSuccess !== false
    ) {
      dispatch(resetBatchStatus());
      setDeleteStudent("");
      setDeleteModal(false);
    }
  }, [demoStudentDeleteSuccess]);

  React.useEffect(() => {
    if (batchPaymentReminderSuccess === true) {
      dispatch(resetBatchPaymentReminderStatus());
    }
  }, [batchPaymentReminderSuccess]);

  const handleSendPaymentReminder = () => {
    const body = { batchId: batchData?.id };
    SendPaymentReminderToBatch(body);
  };

  const hasNurturePay =
    instituteData &&
    Array.isArray(instituteData.integrationsOpted) &&
    instituteData?.integrationsOpted?.includes("NURTURE_PAY_EASEBUZZ");

  const branches = useSelector((state: any) => state.branch.branchList);
  const subMerchangeInfo = findBranchById(batchData?.branchId, branches);

  return (
    <div className={styles.studentSec}>
      <Accordion
        expanded={expanded === `panel1`}
        onChange={handleChange(`panel1`)}
        sx={{
          border: "1px solid #E9E9E9",
          boxShadow: "none",
          borderRadius: "6PX",
          marginBottom: "10PX",

          transition: "0.1s ease-in-out",
          "&:before": {
            display: "none !important",
          },
        }}
      >
        <AccordionSummary
          sx={{
            color: "#142C44",
            borderRadius: "6px 6px 0px 0",
            border: "none",
          }}
          expandIcon={null}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className={styles.studentAccordHeadTitleContainer}>
            <div className={styles.studentAccordHeadTitle}>
              {`Students (${
                batchData?.batchConductType === "DEMO_BATCH"
                  ? batchData?.demoStudents?.length
                  : batchData?.students?.length
              })`}
            </div>
            {/* {(batchData?.paymentType === "REGULAR" ||
              batchData?.paymentType === "MEMBERSHIP") &&
              batchData?.batchConductType === "REGULAR_BATCH" &&
              batchData?.students?.length > 0 && (
                <div className={styles.studentAccordHeadTitle}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "4PX",
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      height: "38px",
                      overflow: "hidden",
                    }}
                  >
                    <Tooltip title="Active Leads" arrow>
                      <span>
                        <button
                          style={{
                            cursor: "pointer",
                            border: "none",
                            background: leadStatusCheck
                              ? "#fff"
                              : "rgba(17, 200, 155, 0.10)",
                            height: "37px",
                            width: "37px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                          }}
                          onClick={() => {
                            setLeadStatusCheck(false);
                          }}
                        >
                          <img
                            src={
                              !leadStatusCheck
                                ? leadActiveIcon
                                : leadActiveDefault
                            }
                            alt="leadActiveIcon"
                          />
                        </button>
                      </span>
                    </Tooltip>

                    <div
                      style={{
                        background: "#D0D5DD",
                        width: "1px",
                        height: "100%",
                      }}
                    ></div>
                    <Tooltip title="Lost Leads" arrow>
                      <span>
                        <button
                          style={{
                            cursor: "pointer",
                            border: "none",
                            background: leadStatusCheck
                              ? "rgba(236, 57, 57, 0.12)"
                              : "#fff",
                            height: "37px",
                            width: "37px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                          }}
                          onClick={() => {
                            setLeadStatusCheck(true);
                          }}
                        >
                          <img
                            src={
                              !leadStatusCheck ? leadLostDefault : leadLostIcon
                            }
                            alt="leadLostIcon"
                          />
                        </button>
                      </span>
                    </Tooltip>
                  </div>
                  <SaveBtn
                    onClick={handleSendPaymentReminder}
                    buttonText={
                      hasNurturePay
                        ? "Send Payment Link"
                        : "Send Payment Reminder"
                    }
                    loader={batchPaymentReminderLoading}
                  />
                </div>
              )} */}
          </div>
        </AccordionSummary>

        <AccordionDetails
          className={styles.summaryDesc}
          sx={{
            borderRadius: "0 0 6px 6px",
            border: "none",
          }}
        >
          <div className={styles.studentAccordHeadTitleContainer}>
            <div className={styles.studentAccordHeadTitle}></div>
            {(batchData?.paymentType === "REGULAR" ||
              batchData?.paymentType === "MEMBERSHIP") &&
              batchData?.batchConductType === "REGULAR_BATCH" &&
              batchData?.students?.length > 0 && (
                <div
                  className={styles.studentAccordHeadTitle}
                  style={{ marginBottom: "10px" }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "4PX",
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      height: "38px",
                      overflow: "hidden",
                    }}
                  >
                    <Tooltip title="Active Students" arrow>
                      <span>
                        <button
                          style={{
                            cursor: "pointer",
                            border: "none",
                            background: leadStatusCheck
                              ? "#fff"
                              : "rgba(17, 200, 155, 0.10)",
                            height: "37px",
                            width: "37px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                          }}
                          onClick={() => {
                            setLeadStatusCheck(false);
                          }}
                        >
                          <img
                            src={
                              !leadStatusCheck
                                ? leadActiveIcon
                                : leadActiveDefault
                            }
                            alt="leadActiveIcon"
                          />
                        </button>
                      </span>
                    </Tooltip>

                    <div
                      style={{
                        background: "#D0D5DD",
                        width: "1px",
                        height: "100%",
                      }}
                    ></div>
                    <Tooltip title="Lost Students" arrow>
                      <span>
                        <button
                          style={{
                            cursor: "pointer",
                            border: "none",
                            background: leadStatusCheck
                              ? "rgba(236, 57, 57, 0.12)"
                              : "#fff",
                            height: "37px",
                            width: "37px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                          }}
                          onClick={() => {
                            setLeadStatusCheck(true);
                          }}
                        >
                          <img
                            src={
                              !leadStatusCheck ? leadLostDefault : leadLostIcon
                            }
                            alt="leadLostIcon"
                          />
                        </button>
                      </span>
                    </Tooltip>
                  </div>
                  <SaveBtn
                    onClick={handleSendPaymentReminder}
                    buttonText={
                      hasNurturePay &&
                      subMerchangeInfo?.subMerchantAdded === true &&
                      subMerchangeInfo?.subMerchantId !== ""
                        ? "Send Payment Link"
                        : "Send Payment Reminder"
                    }
                    loader={batchPaymentReminderLoading}
                  />
                </div>
              )}
          </div>
          <div className={styles.studentItemsWrap}>
            {(batchData?.batchConductType === "DEMO_BATCH"
              ? batchData?.demoStudents?.filter((d: any) =>
                  leadStatusCheck === true
                    ? d?.enquiryStatus === "LOST"
                    : d?.enquiryStatus === "ACTIVE"
                )
              : batchData?.students?.filter((d: any) =>
                  leadStatusCheck === true
                    ? d?.enquiryStatus === "LOST"
                    : d?.enquiryStatus === "ACTIVE"
                )
            )?.length > 0 ? (
              (batchData?.batchConductType === "DEMO_BATCH"
                ? batchData?.demoStudents?.filter((d: any) =>
                    leadStatusCheck === true
                      ? d?.enquiryStatus === "LOST"
                      : d?.enquiryStatus === "ACTIVE"
                  )
                : batchData?.students?.filter((d: any) =>
                    leadStatusCheck === true
                      ? d?.enquiryStatus === "LOST"
                      : d?.enquiryStatus === "ACTIVE"
                  )
              )?.map((item: any) => (
                <div key={item?.id} className={styles.studentItemRow}>
                  <div className={styles.studentItemRowLeft}>
                    <Avatar
                      alt="avatar"
                      sx={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        fontSize: "12px",
                        background: "#4E647A",
                        fontFamily: "Poppins",
                        fontWeight: "400",
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {batchData?.batchConductType === "DEMO_BATCH"
                        ? item?.studentFullName?.charAt(0)
                        : item?.studentFirstName?.charAt(0)}
                    </Avatar>
                    {batchData?.batchConductType === "DEMO_BATCH"
                      ? item?.studentFullName
                      : item?.studentFirstName + " " + item?.studentLastName}
                  </div>
                  {batchData?.batchConductType === "DEMO_BATCH" &&
                    hasBatchAccess && (
                      <DeleteBtn onClick={() => handleDelete(item)} />
                    )}
                </div>
              ))
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "12px",
                  background: "#667085",
                  fontFamily: "Poppins",
                  fontWeight: "400",
                  color: "#fff",
                  padding: "20px",
                }}
              >
                No Students Assigned
              </div>
            )}
          </div>
        </AccordionDetails>
      </Accordion>
      {deleteModal && (
        <DeletePopup
          open={deleteModal}
          onClose={handleDeleteClosePopup}
          noBtnClick={handleDeleteClosePopup}
          yesBtnClick={handleDeleteStudent}
          loader={demoStudentDeleteLoading}
          title={"Do you really want to delete this student from the batch?"}
        />
      )}
    </div>
  );
}

export default BatchStudents;
